export class ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  statusCode: number;

  constructor(success: boolean, message: string, data: T, statusCode: number) {
    this.success = success;
    this.message = message;
    this.data = data;
    this.statusCode = statusCode;
  }
}
